import * as types from '../constants/ActionTypes.js'

const initLoginState = {
  users: [],
  loggedin: {
    id: undefined,
    username: undefined
  },
  logOutPossible: true
}

export const loginReducer = function loginState(state = initLoginState, action) {
  const users = [];
  switch (action.type) {
    case types.LOGIN:
      return Object.assign({}, state, {
        loggedin: {
          id: action.id,
          username: action.username
        }
      })
    case types.LOGOUT:
      return Object.assign({}, state, {
        loggedin: {
          id: undefined,
          username: undefined
        }
      })
    case types.RECEIVE_USERS:
      action.json.map((user) => {
        users.push(user);
        return ''
      })
      return Object.assign({}, state, {
        users
      })
    case types.CLEAR_STATE:
      return Object.assign({}, initLoginState, {});
    case types.SET_LOGOUT:
      return Object.assign({}, state, {
        logOutPossible: action.setLogOut
      })
    default:
      return state;
  }
}




// WEBPACK FOOTER //
// src/reducers/login.js